var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        "background-color": "#fff",
        "border-radius": "10px",
        overflow: "hidden",
      },
    },
    [
      _c("a-page-header", {
        staticStyle: { border: "1px solid rgb(235, 237, 240)" },
        attrs: { title: "返回" },
        on: {
          back: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      }),
      _c(
        "div",
        { staticClass: "steps-container" },
        [
          _c(
            "a-steps",
            { attrs: { current: _vm.current } },
            _vm._l(_vm.steps, function (item) {
              return _c("a-step", {
                key: item.title,
                attrs: { title: item.title },
              })
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "steps-content" },
            [
              _c(_vm.steps[_vm.current].content, {
                tag: "component",
                attrs: {
                  quesData: _vm.quesData,
                  evaluationId: _vm.evaluationId,
                },
                on: {
                  nextClick: _vm.next,
                  prevClick: _vm.prev,
                  refreshQuesData: _vm.getQuesData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }